var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7507 7.27811C19.4929 7.02034 19.1432 6.87553 18.7786 6.87553C18.414 6.87553 18.0643 7.02034 17.8065 7.27811L11.0002 14.0844L4.19399 7.27811C3.93466 7.02765 3.58733 6.88905 3.22681 6.89219C2.86629 6.89532 2.52143 7.03993 2.26649 7.29486C2.01155 7.5498 1.86695 7.89467 1.86381 8.25519C1.86068 8.61571 1.99927 8.96303 2.24974 9.22236L10.0281 17.0007C10.286 17.2585 10.6356 17.4033 11.0002 17.4033C11.3648 17.4033 11.7145 17.2585 11.9724 17.0007L19.7507 9.22236C20.0085 8.96451 20.1533 8.61484 20.1533 8.25024C20.1533 7.88564 20.0085 7.53596 19.7507 7.27811Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowGray);
export default __webpack_public_path__ + "static/media/IconArrowGray.7bda2580355b0c61716de5ef881aa5de.svg";
export { ForwardRef as ReactComponent };